<ct-drop-zone
  mobiDropZone
  data-testid="mobi-drop-zone"
  [class.disabled]="disableUpload()"
  [disableDrop]="disableUpload()"
  (fileDropped)="onFileDropped($event)"
  (click)="triggerFilePicker()"
>

  <input
    #fileInput
    type="file"
    [hidden]="true"
    [multiple]="allowMultiple()"
    [accept]="acceptAttribute()"
    (change)="onFileSelected(fileInput.files!)"
  >

  <ct-drop-zone-content>
    <mat-icon
      class='cloud-icon'
      rs-icon-symbols-outline
      fontIcon="cloud_upload"
    />
    <ct-drop-zone-title>
      <span>{{ "FILE_UPLOAD_COMPONENT.DRAG_AND_DROP" | translate }}</span>
      <span rs-font="light"> {{ "FILE_UPLOAD_COMPONENT.YOUR_FILES_HERE_OR" | translate }} </span>
      <span>{{ "BROWSE_FILES" | translate }}</span>
    </ct-drop-zone-title>

    <section rs-font="light">
      {{ 'FILE_TYPES' | translate }} {{ fileTypesFormatted() }}
    </section>

    <section rs-font="light">
      {{ 'FILE_UPLOAD_COMPONENT.MAX_FILE_SIZE' | translate }}: {{ maxFileSizeFormatted() }}
    </section>

    <section rs-font="light">
      {{ 'FILE_UPLOAD_COMPONENT.MAX_FILES' | translate }}: {{ maxFiles() }}
    </section>
  </ct-drop-zone-content>
</ct-drop-zone>

@if (hasErrorFiles()) {
<ct-file-list-errors animate.leave="leaving">
  <ct-file-error-title>
    <h3>{{ 'ERROR_FILES_ADDED' | translate }}</h3>
    <button
      (click)="closeErrorFilesBox()"
      mat-icon-button
      type="button"
    >
      <mat-icon fontIcon="clear" />
    </button>
  </ct-file-error-title>

  @for (fileError of errorFiles(); track fileError.file.name) {
  <ct-file-error-item data-testid="mobi-file-uploader-error-item">
    <span>{{ fileError.file.name }}</span>
    @for (errorKey of fileError.errorKeys(); track errorKey) {
    <rs-hint rs-font-size="sm">{{ errorKey | translate }}</rs-hint>
    }
  </ct-file-error-item>
  }
</ct-file-list-errors>
}

@if (hasFiles()) {
<ct-file-list>
  <ct-file-list-counter rs-font="light">
    <h3>{{ 'FILES_TO_UPLOAD' | translate }}</h3>
    <rs-chip rs-chip--color="grey">{{ activeFilesCount() }}/{{ maxFiles() }}</rs-chip>
  </ct-file-list-counter>

  @for (file of validFiles(); track file.file.name; let i = $index) {
  <ct-file-item
    data-testid="mobi-file-uploader-file-item"
    [attr.status]="file.status()"
    animate.enter="enter"
  >
    <ct-file-info-icon>
      <mat-icon
        rs-icon-symbols-outline
        [fontIcon]="iconMap[file.status()]"
      />
    </ct-file-info-icon>

    <ct-file-info rs-font="light">{{ file.file.name }}</ct-file-info>

    <ct-file-progress-bar-wrapper>
      <mat-progress-bar
        [class.upload-successful]="file.progress() === 100"
        [class.upload-error]="file.errorKeys().length > 0"
        [value]="file.progress()"
        mode="determinate"
      />
    </ct-file-progress-bar-wrapper>

    <ct-file-actions>
      @if (file.status() === 'uploading') {
      <button
        data-testid="mobi-file-uploader-cancel-upload-btn"
        mat-icon-button
        type="button"
        (click)="cancelUpload(file)"
      >
        <mat-icon fontIcon="clear" />
      </button>
      }
      @if (file.status() !== 'uploading') {
      <button
        data-testid="mobi-file-uploader-remove-file-btn"
        [disabled]="file.status() == 'completed'"
        mat-icon-button
        type="button"
        (click)="removeFile(i)"
        data-testid="btn-file-delete"
      >
        <mat-icon fontIcon="delete_outline" />
      </button>
      }
    </ct-file-actions>
  </ct-file-item>
  }
</ct-file-list>
}